import { Component } from '@angular/core';

@Component({
  selector: 'app-businessnetwork',
  templateUrl: './businessnetwork.component.html',
  styleUrls: ['./businessnetwork.component.scss']
})
export class BusinessnetworkComponent {

}
